export default () => ({
  trigger: {
    name: 'order_block.pick_up_in_store',
    params: {},
  },
  config: {
    event: {
      name: 'select_pickup',
      params: {
        sub_feature: null,
      },
    },
  },
});
